// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__1GvsK","content":"Consent_content__3Q11c","footer":"Consent_footer__2fs7V"};